import { render } from "./CoverSearchBar.vue?vue&type=template&id=6ac83135"
import script from "./CoverSearchBar.vue?vue&type=script&lang=js"
export * from "./CoverSearchBar.vue?vue&type=script&lang=js"

import "./CoverSearchBar.vue?vue&type=style&index=0&id=6ac83135&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__